/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import ClinicLocationForm from './ClinicLocationForm';
import { useClinicLocationUpdate } from '../../hooks/clinic/useClinicLocationUpdate';

const EditClinicLocation = forwardRef(function EditClinicLocation(
  { formValues, onSuccess, onError },
  ref
) {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { loading: updatingClinicLocation, updateClinicLocation } =
    useClinicLocationUpdate();

  useImperativeHandle(ref, () => ({
    reset: () => formRef?.current?.reset,
  }));

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        paymentMethod: data?.paymentMethod,
        status: data?.status,
        adminEmail: data?.adminEmail,
        accountEmail: data?.accountEmail,
        doctorEmail: data?.doctorEmail,
      };
      const response = await updateClinicLocation(data.clinicLocationId, payload);
      setLoading(false);
      onSuccess?.({ ...response, ...payload });
    } catch (error) {
      setLoading(false);
      onError?.(error);
    }
  };

  return (
    <ClinicLocationForm
      key={formValues?.clinicLocationId}
      formValues={formValues}
      onSubmit={onSubmit}
      loading={loading || updatingClinicLocation}
    />
  );
});

EditClinicLocation.propTypes = {
  formValues: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default EditClinicLocation;
